import { render, staticRenderFns } from "./ItemListByItem.vue?vue&type=template&id=acde95bc&scoped=true&"
import script from "./ItemListByItem.vue?vue&type=script&lang=js&"
export * from "./ItemListByItem.vue?vue&type=script&lang=js&"
import style0 from "./ItemListByItem.vue?vue&type=style&index=0&id=acde95bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acde95bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VDataTable})
